import React, { Fragment, memo, useState } from "react";

import { Option } from './Option';
import { NewOption } from './NewOption';

export const OptionList = memo((props) => {
  const { items, filters, addOption, removeOption } = props;

  return (
    <>
      <table className="table table-bordered table-hover table-condensed">
          <thead>
            <tr>
              <th style={{ width: 90 + 'px' }}>code</th>
              <th><i className="fas fa-tag" /> ラベル名/備考(ja)</th>
              <th><i className="fas fa-tag" /> ラベル名/備考(en)</th>
              <th><i className="fas fa-pencil-alt" /> 操作</th>
              <th><i className="fas fa-filter" /> 選択条件</th>
            </tr>
        </thead>
        <tbody>
          {items.map(item => 
            <Option key={item.id} item={item} filters={filters} removeOption={removeOption} />
          )}
          <NewOption addOption={addOption} />
        </tbody>
      </table>
    </>
  );
});
